import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import { StateProvider } from "./StateProvider";

const rootElement = document.getElementById("root");

ReactDOM.render(
  <React.StrictMode>
    <StateProvider>
      <App />
    </StateProvider>
  </React.StrictMode>,
  rootElement
);
